import { Button, Grid, TextField } from '@mui/material';
import _ from 'lodash';
import React, { } from 'react';
import { useDispatch } from 'react-redux';
import SupportSheetTimesheetModel from './models/SupportSheetTimesheetModel';

interface SupportSheetTimesheetProp {
    items: SupportSheetTimesheetModel[],
    className?: string,
    errorClassName?: string,
    disabled?: boolean,
    onChange?: (selectedItem: SupportSheetTimesheetModel[]) => void,
}

export const getDefaultTimeSheet = () => {
    return [{
        index: 0,
        date: "",
        vesselStatus: ""
    } as SupportSheetTimesheetModel,
    {
        index: 1,
        date: "",
        vesselStatus: ""
    } as SupportSheetTimesheetModel,
    {
        index: 2,
        date: "",
        vesselStatus: ""
    } as SupportSheetTimesheetModel];
}

const SupportSheetTimesheet: React.FunctionComponent<SupportSheetTimesheetProp> = (props) => {
    const dispatch = useDispatch();

    return (
        <div className={props.errorClassName}>
            <Grid container>
                <Grid item xs={4}>
                    <b>Timesheet</b>
                </Grid>
                <Grid item xs={8}>
                    <b>Vessel's status</b>
                </Grid>
            </Grid>
            {
                props.items.map((item: SupportSheetTimesheetModel, index: number) => (
                    <>
                        <Grid container>
                            <Grid item xs={4}>
                                <TextField
                                    label="Date"
                                    fullWidth
                                    disabled={props.disabled}
                                    value={item.date.toUpperCase()}
                                    onChange={(event) => {
                                        if (props.onChange) {
                                            props.items[index].date = event.target.value;
                                            props.onChange(props.items);
                                        }
                                    }}
                                    className='cargo-input-component'
                                />
                            </Grid>
                            <Grid item xs={7}>
                                <TextField
                                    label="Vessel's status"
                                    fullWidth
                                    disabled={props.disabled}
                                    value={item.vesselStatus.toUpperCase()}
                                    onChange={(event) => {
                                        if (props.onChange) {
                                            props.items[index].vesselStatus = event.target.value;
                                            props.onChange(props.items);
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <Button
                                    className='table-action-button'
                                    disabled={props.disabled}
                                    onClick={() => {
                                        if (props.onChange) {
                                            props.items.splice(index, 1);
                                            props.onChange(props.items);
                                        }
                                    }}
                                    variant='text'
                                >
                                    <i className="fa fa-times" aria-hidden="true"></i>
                                </Button>
                            </Grid>
                        </Grid>
                    </>
                ))
            }
            <Button
                color="secondary"
                variant='outlined'
                disabled={props.disabled}
                onClick={() => {
                    let newItem = {
                        index: props.items.length,
                        date: "",
                        vesselStatus: ""
                    } as SupportSheetTimesheetModel;

                    props.items.push(newItem);

                    if (props.onChange) {
                        props.onChange(props.items);
                    }
                }}
            >Add</Button>
        </div>
    )
};

export default SupportSheetTimesheet;